import { render, staticRenderFns } from "./WarehouseComponent.vue?vue&type=template&id=c98cad14&scoped=true"
import script from "./WarehouseComponent.vue?vue&type=script&lang=js"
export * from "./WarehouseComponent.vue?vue&type=script&lang=js"
import style0 from "./WarehouseComponent.vue?vue&type=style&index=0&id=c98cad14&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98cad14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c98cad14')) {
      api.createRecord('c98cad14', component.options)
    } else {
      api.reload('c98cad14', component.options)
    }
    module.hot.accept("./WarehouseComponent.vue?vue&type=template&id=c98cad14&scoped=true", function () {
      api.rerender('c98cad14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/warehouse/WarehouseComponent.vue"
export default component.exports